//prefixes of implementation that we want to test
const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

//prefixes of window.IDB objects
window.IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction;
window.IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange;

if (!indexedDB) {
  window.alert("Your browser doesn't support a stable version of IndexedDB.");
}

const DB_NAME = 'calendar_builder';
const version = 1;

export const Stores = {
  Images: 'images'
}

let db;

export function initDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, version);

    request.onupgradeneeded = () => {
      const db = request.result;

      // if the data object store doesn't exist, create it
      if (!db.objectStoreNames.contains(Stores.Images)) {
        db.createObjectStore(Stores.Images, { keyPath: 'id' });
      }
    };

    request.onsuccess = () => {
      db = request.result;
      resolve(true);
    };

    request.onerror = () => {
      reject(false);
    };
  });
}

export function addData(storeName, data) {
  if (!db) {
    console.log('No database connection');
    return;
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const res = store.add(data);
    res.onsuccess = (event) => {
      resolve(event.target.result);
    }
    res.onerror = (event) => {
      reject(event.target.error)
    }
  });
}

export function getStoreData(storeName) {
  if (!db) {
    console.log('No database connection');
    return;
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    const res = store.getAll();
    res.onsuccess = (event) => {
      resolve(event.target.result);
    }
    res.onerror = (event) => {
      reject(event.target.error)
    }
  });
}

export function getStoreDataByKey(storeName, key) {
  if (!db) {
    console.log('No database connection');
    return;
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    const res = store.get(key);
    res.onsuccess = (event) => {
      resolve(event.target.result);
    }
    res.onerror = (event) => {
      reject(event.target.error)
    }
  });
}

export function deleteData(storeName, key) {
  if (!db) {
    console.log('No database connection');
    return;
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const res = store.delete(key);

    res.onsuccess = () => {
      resolve(true);
    }
    res.onerror = () => {
      reject(false);
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/db.js